export const DeploymentEnvironment: "staging" | "production" = "production";
